import React from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { PostsLaneId } from './postsModel';
import { postsMessages } from './postsMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './Posts.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface PostsPhoneTabsProps {
  lane: PostsLaneId;
  counts: Record<PostsLaneId, number>;
  onChange: (lane: PostsLaneId) => void;
}

const LANES: ReadonlyArray<PostsLaneId> = ['ready', 'scheduled', 'posted'];
const LABELS = {
  ready: postsMessages.laneReadyShort,
  scheduled: postsMessages.laneScheduled,
  posted: postsMessages.lanePosted,
} as const;

/** Under 576 px the three lanes become a segmented control (design assets-rethink c3). */
const PostsPhoneTabsComponent: React.FC<PostsPhoneTabsProps> = ({ lane, counts, onChange }) => {
  const intl = useIntl();
  return (
    <div className={styles.phoneTabs} role="tablist" data-testid="posts-phone-tabs">
      {LANES.map((one) => (
        <button
          key={one}
          type="button"
          role="tab"
          aria-selected={one === lane}
          className={clsx(styles.phoneTab, one === lane && styles.phoneTabOn)}
          onClick={() => onChange(one)}
        >
          {intl.formatMessage(LABELS[one])} {intl.formatNumber(counts[one])}
        </button>
      ))}
    </div>
  );
};

export const PostsPhoneTabs = TypedMemo(PostsPhoneTabsComponent);
